export default __webpack_public_path__ + "static/media/flag-finland.fed00b77.svg";